export type { ErrorProps } from './Error.types'

export { default } from './Error'
